<template>
  <div v-if="!loggedIn">
    <amplify-authenticator>
      <amplify-sign-in
        slot="sign-in"
        :hide-sign-up="true">
      </amplify-sign-in>
    </amplify-authenticator>
  </div>

</template>

<script>
import { mapState } from 'vuex'

export default {
  name: 'Auth',
  computed: {
    ...mapState(['loggedIn'])
  }
}
</script>

<style scoped>
.auth {
  margin:0 auto;
  padding:100px;
  padding-top:150px;
  height:750px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.auth .Button__button {
  background-color: #057faf;
  border-radius:  4px;
  font-weight: 600;
  box-shadow: 0px 3px 1px -2px rgba(0, 0, 0, 0.2);
}

a {
  color: #057faf
}
</style>
